import { ApolloQueryResult, gql } from '@apollo/client';
import {
  GetShippingBlockDataQueryResult,
  useDeleteShippingOptionMutation,
} from 'lib/graphql-generated';
import { useEffect, useRef, useState } from 'react';
import { Transition } from '@headlessui/react';
import { useHasClickedOutside } from 'lib/hooks/use-has-clicked-outside';
import currency from 'currency.js';

interface Props {
  name: string;
  description: string;
  id;
  from: number;
  to: number;
  price: number;
}

const DELETE_SHIPPING_OPTION = gql`
  mutation deleteShippingOption($id: uuid!, $today: timestamptz!) {
    update_shipping_options_by_pk(
      pk_columns: { id: $id }
      _set: { deleted_at: $today }
    ) {
      id
    }
  }
`;

export const ShippingOption = (props: Props) => {
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false);
  const [isEditing, setEditing] = useState<boolean>(false);
  const menuRef = useRef(null);
  const hasClickedOutside = useHasClickedOutside(menuRef);
  const [
    handleDelete,
    { data, loading, error },
  ] = useDeleteShippingOptionMutation({
    variables: {
      id: props.id,
      today: new Date().toISOString(),
    },
    refetchQueries: ['GetShippingBlockData'],
  });

  useEffect(() => {
    if (isMenuOpen && hasClickedOutside) {
      setMenuOpen(false);
    }
  });

  return (
    <li className='[ ] [ flex flex-row flex-wrap ] '>
      <div className='relative p-4 w-full flex flex-col space-y-2 md:space-y-0 md:pr-6 md:grid md:grid-cols-3 rela'>
        <div className='absolute right-1 bottom-0'>
          <button
            className='w-8 h-8 ml-auto mb-auto bg-white inline-flex items-center justify-center text-gray-400 rounded-full bg-transparent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-default text-xs'
            onClick={() => setMenuOpen(true)}>
            Edit
          </button>
          <Transition
            show={isMenuOpen}
            enter='transition ease-out duration-100'
            enterFrom='transform opacity-0 scale-95'
            enterTo='transform opacity-100 scale-100'
            leave='transition ease-in duration-75'
            leaveFrom='transform opacity-100 scale-100'
            leaveTo='transform opacity-0 scale-95'>
            <div
              ref={menuRef}
              className='z-10 origin-bottom-right absolute right-0 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100'
              role='menu'
              aria-orientation='vertical'
              aria-labelledby='options-menu'>
              <div className='py-1'>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleDelete();
                  }}
                  className='block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900'
                  role='menuitem'>
                  Delete
                </button>
              </div>
            </div>
          </Transition>
        </div>
        <span className=' font-medium text-gray-900'>{props.name}</span>
        <p id='plan-option-pricing-1' className=' text-sm md:text-center'>
          <span className='font-medium'>
            {props.from} - {props.to ? props.to : '∞'} books
          </span>
        </p>
        <p id='plan-option-limit-1' className='text-sm md:text-right'>
          {currency(props.price, {
            symbol: '£',
            fromCents: true,
          }).format()}
        </p>
        <p className='text-sm col-span-full pr-4'>{props.description}</p>
      </div>
    </li>
  );
};
